import PropTypes from 'prop-types';

// Styles
import styles from './EmployeInformation.module.css';

// Components
import { Avatar } from '../Avatar/Avatar';

export function EmployeInformation({ resource }) {
  return (
    <div className={styles.container}>
      <Avatar size="small" src={resource.photo} title={resource.name} />
      <div className={styles.info}>
        <h5 className={styles.name}>{resource.name}</h5>
        <p className={styles.workingPositions}>{resource.position}</p>
      </div>
    </div>
  );
}

EmployeInformation.propTypes = {
  resource: PropTypes.shape({
    photo: PropTypes.string,
    name: PropTypes.string,
    position: PropTypes.string,
  }).isRequired,
};

export default EmployeInformation;
